function mute({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${(dimensions * 9) / 10 || '18'} height=${dimensions || '20'} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.30493 19.75C9.40493 19.75 10.3049 18.85 10.3049 17.75H6.30493C6.30493 18.85 7.20493 19.75 8.30493 19.75ZM8.30493 4.25C10.7949 4.25 12.3049 6.27 12.3049 8.75V8.85L14.3049 10.85V8.75C14.3049 5.68 12.6749 3.11 9.80493 2.43V1.75C9.80493 0.92 9.13493 0.25 8.30493 0.25C7.47493 0.25 6.80493 0.92 6.80493 1.75V2.43C6.56493 2.49 6.33493 2.58 6.11493 2.66L7.75493 4.3C7.93493 4.28 8.11493 4.25 8.30493 4.25ZM1.71493 1.1L0.304932 2.51L3.11493 5.32C2.59493 6.32 2.30493 7.49 2.30493 8.75V13.75L0.304932 15.75V16.75H14.5449L16.2849 18.49L17.6949 17.08L1.71493 1.1ZM12.3049 14.75H4.30493V8.75C4.30493 8.07 4.42493 7.43 4.64493 6.85L12.3049 14.51V14.75Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default mute;
